import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Badge, IconCheckFill } from '@fhs/ui';
import { tokens } from '@fhs/ui';

interface Props {
  currentStep: number;
  totalSteps: number;
  style?: StyleProp<ViewStyle>;
}

export function StepsProgress({ currentStep, totalSteps, style }: Props) {
  const isCompleted = (step: number) => step < currentStep;
  return (
    <View style={[styles.container, style]}>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <React.Fragment key={index}>
          {isCompleted(index) ? (
            <IconCheckFill size={24} color={tokens.colors.$success} />
          ) : (
            <Badge
              circular
              color={tokens.colors.$black10}
              textColor={tokens.colors.$placeholderText}
            >
              {index + 1}
            </Badge>
          )}

          {index < totalSteps - 1 && (
            <View
              style={[
                styles.separator,
                {
                  backgroundColor: isCompleted(index + 1)
                    ? tokens.colors.$success
                    : tokens.colors.$black10,
                },
              ]}
            />
          )}
        </React.Fragment>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  separator: {
    flex: 1,
    height: 2,
    marginHorizontal: 4,
  },
});
